import * as React from 'react';

import { Alert } from 'antd';

export default function WebhookInativationAlert() {
  const today = new Date();
  const inactivationDate = new Date('2026-04-30T23:59:59');

  if (today > inactivationDate) {
    return null;
  }

  return (
    <>
      <Alert
        type='warning'
        showIcon
        message='Chegou a hora de migrar para a Developer Hub!'
        description={
          <div className='flex flex-col gap-2'>
            <p className='text-sm'>
              O Webhook atual será descontinuado em 11/01/2027, e as integrações agora devem acontecer pela Developer
              Hub.
            </p>
            <p className='text-sm'>
              Com ela você ganha maior estabilidade, redisparo em massa de eventos com falha e um canal exclusivo para
              desenvolvedores.
            </p>
            <p className='text-sm'>
              👉 Se sua conta ainda usa este webhook, recomendamos a migração o quanto antes para evitar impactos.
            </p>
            <p className='text-sm'>
              <a
                href='https://ajuda.eduzz.com/como-migrar-minhas-integrações-para-a-developer-hub-'
                target='_blank'
                rel='noopener noreferrer'
              >
                🔗 Saiba mais sobre o novo webhook e como migrar
              </a>
            </p>
          </div>
        }
      />
    </>
  );
}
